<template>
    <div class="sa-list-component">
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ praticheSiatRowsNumber }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="praticheSiatRowsNumber" :per-page="perPage" :align="'right'" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table v-if="praticheSiatItems.length > 0" sticky-header ref="table" stacked="xl" striped :items="praticheSiatItems" :fields="fields" :current-page="1" :per-page="perPage" head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + (row.index + 1) }}
                    </template>
                    <template #cell(codice)="row">
                        <b-badge variant="primary">
                            {{ row.item.codice }}
                        </b-badge>
                    </template>
                    <template #cell(stato)="row">
                        <span :class="getClassBadge(row.item)">{{ row.item.stato }}</span>
                    </template>
                    <template #cell(bisogno)="row">
                        <span :class="getClassBadgeBisogno(row.item)">{{ row.item.bisogno }}</span>
                    </template>
                    <template #cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button v-b-tooltip.hover class="mr-1 ml-1 no-text" size="sm" variant="outline-success width-sm no-text" title="Gestisci intervento" :disabled="!row.item.eventiPrestazioniIntevalliBean || row.item.eventiPrestazioniIntevalliBean.statoIntervento === 'ESEGUITO'" @click="onClickGestisciIntervento(row.item)">
                                <i class="fas fa-check-circle"></i>
                            </b-button>
                            <b-button v-b-tooltip.hover class="mr-1 ml-1 no-text" size="sm" variant="outline-info width-sm no-text" title="Invia al SIAT" :disabled="!row.item.eventiPrestazioniIntevalliBean || row.item.eventiPrestazioniIntevalliBean.statoIntervento !== 'ESEGUITO' || invioSiatInCorso !== null" @click="onClickInviaAlSiat(row.item)">
                                <b-spinner v-if="invioSiatInCorso === geteventoId(row.item)" small></b-spinner>
                                <i v-else class="fas fa-paper-plane"></i>
                            </b-button>
                            <b-button v-b-tooltip.hover class="mr-1 ml-1 no-text" size="sm" variant="outline-danger width-sm no-text" title="Annulla esecuzione" aria-label="Annulla esecuzione" :disabled="!row.item.eventiPrestazioniIntevalliBean || row.item.eventiPrestazioniIntevalliBean.statoIntervento !== 'ESEGUITO' || row.item.eventiPrestazioniIntevalliBean.stato === 'RENDICONTATO' || invioSiatInCorso !== null" @click="onClickAnnullaEsecuzione(row.item)">
                                <i class="fas fa-undo"></i>
                            </b-button>
                            <b-button class="mr-1 ml-1 no-text" size="sm" variant="outline-primary width-sm no-text" @click="onClickApriDettaglioPratica(row.item)">
                                <i class="fas fa-eye"></i>
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
                <NoDataComponent v-else ref="cmpNoDataComponent" title="Non sono presenti Pratiche" nome="no-data" subtitle="" icon="fas fa-clipboard" />
            </div>
        </div>
        <SiatRiepilogoPraticheModalComponent ref="cmpSiatRiepilogoPraticheModalComponent" @interventoEseguito="onInterventoEseguito" />
    </div>
</template>

<script>
import NoDataComponent from "../../../template/components/utility/NoDataComponent.vue";
import SiatMixin from "../mixins/SiatMixin.js";
import SiatRiepilogoPraticheModalComponent from "./SiatRiepilogoPraticheModalComponent.vue";
// import praticaa da "./praticaa";
export default {
    components: { NoDataComponent, SiatRiepilogoPraticheModalComponent },
    mixins: [SiatMixin],
    data() {
        return {
            items: [],
            currentPage: 1,
            perPage: 50,
            invioSiatInCorso: null,
            aggiornaStatoPathResource: "/siateventiprestazioniinterventistatistorico",
            praticheSiatPathResource: "/siatpratiche/riepilogo",

            fields: [
                {
                    label: "",
                    key: "index",
                    thStyle: "width: 1.5rem",
                },
                {
                    label: "Codice Pratica",
                    key: "codice",
                },
                {
                    label: "Stato",
                    key: "stato",
                },
                {
                    label: "Assistito",
                    key: "assistito",
                },
                {
                    label: "Bisogno",
                    key: "bisogno",
                    formatter: (value) => {
                        if (value == null) {
                            return "--";
                        }
                        return value.toUpperCase();
                    },
                },
                {
                    label: "Descrizione Intervento",
                    key: "tipoPrestazioneDescrizione",
                },
                /*{
                    label: "Numero Intervento",
                    key: "eventiPrestazioniIntevalliBean.numeroIntervento",
                },*/
                {
                    label: "Data Prevista Esecuzione",
                    key: "eventiPrestazioniIntevalliBean.dataPrevista",
                    formatter: (value) => {
                        if (value == null) {
                            return "--";
                        }

                        return this.formatDateTime(value);
                    },
                },
                {
                    label: "Stato Intervento",
                    key: "eventiPrestazioniIntevalliBean.statoIntervento",
                },
                {
                    label: "Data Effettiva Esecuzione",
                    key: "eventiPrestazioniIntevalliBean.dataEffettivaEsecuzione",
                    formatter: (value) => {
                        if (value == null) {
                            return "--";
                        }

                        return this.formatDateTime(value);
                    },
                },
                {
                    label: "",
                    key: "actions",
                    class: "sa-table-column-action-double",
                },
            ],
        };
    },
    computed: {},
    watch: {
        currentPage: function () {
            this.loadData();
        },
    },
    methods: {
        loadData() {
            let sessionStorage = window.sessionStorage;
            let filter = {
                forPage: this.perPage,
                page: this.currentPage,
            };
            if (sessionStorage["filtroRiepilogoPratiche"]) {
                let filtro = JSON.parse(sessionStorage["filtroRiepilogoPratiche"]);
                filter = { ...filter, ...filtro };
            }
            this.praticheSiatLoadData(filter);
        },
        onClickApriDettaglioPratica(pratica) {
            this.$router.push("/pratichesiat/" + pratica.id);
        },
        onClickGestisciIntervento(item) {
            this.$refs.cmpSiatRiepilogoPraticheModalComponent.show(item);
        },
        onClickInviaAlSiat(item) {
            let eventoId = this.geteventoId(item);
            if (item.eventiPrestazioniIntevalliBean.statoIntervento !== "ESEGUITO") {
                this.$bvToast.toast("È possibile inviare al SIAT solo un intervento eseguito.", { variant: "warning", solid: true });
                return;
            }

            this.invioSiatInCorso = eventoId;
            let payload = { ...item.eventiPrestazioniIntevalliBean };
            this.putResource(this.siatConfermaPianificazionePathResource + "/" + eventoId, payload, this.inviaAlSiatSuccess, this.inviaAlSiatError);
        },
        onClickAnnullaEsecuzione(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sicuro di annullare l'esecuzione?", {
                    title: "Annulla esecuzione",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.annullaEsecuzione(item);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        annullaEsecuzione(item) {
            let me = this;
            let intervento = item.eventiPrestazioniIntevalliBean;
            if (!intervento || intervento.statoIntervento !== "ESEGUITO" || intervento.stato === "RENDICONTATO" || me.invioSiatInCorso !== null) {
                return;
            }
            let payload = {
                idPrestazioniInterventi: intervento.id,
                stato: "PROGRAMMATO",
                dataOra: new Date().getTime(),
            };
            me.openShowModalLoading();
            me.saveResource(me.aggiornaStatoPathResource, payload, me.riportaProgrammatoSuccess, me.riportaProgrammatoError);
        },
        riportaProgrammatoSuccess() {
            let me = this;
            me.loadData();
        },
        riportaProgrammatoError(error) {
            let me = this;
            me.closeShowModalLoading();
            let messaggio = error && error.response && error.response.data && error.response.data.messaggio ? error.response.data.messaggio : "Errore durante il ripristino dell'intervento a programmato.";
            me.$bvToast.toast(messaggio, { variant: "danger", solid: true });
        },
        geteventoId(item) {
            return item.eventoId || (item.eventiPrestazioniIntevalliBean && item.eventiPrestazioniIntevalliBean.eventoId);
        },
        inviaAlSiatSuccess() {
            this.invioSiatInCorso = null;
            this.$bvToast.toast("Intervento inviato al SIAT con successo.", { variant: "success", solid: true });
            this.loadData();
        },
        inviaAlSiatError(error) {
            this.invioSiatInCorso = null;
            let messaggio = error && error.response && error.response.data && error.response.data.messaggio ? error.response.data.messaggio : "Errore durante l'invio dell'intervento al SIAT.";
            this.$bvToast.toast(messaggio, { variant: "danger", solid: true });
        },
        onInterventoEseguito() {
            this.loadData();
        },
        getClassBadge(item) {
            switch (item.stato) {
                case "APERTA":
                    return "sa-ft-badge success";
                case "CHIUSA":
                    return "sa-ft-badge danger";
                default:
                    return "sa-ft-badge";
            }
        },
        getClassBadgeBisogno(item) {
            switch (item.bisogno) {
                case "COMPLESSO":
                    return "sa-ft-badge orange";
                default:
                    return "sa-ft-badge";
            }
        },
        getFormatoEuro(value) {
            return value.toLocaleString("it-IT", {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },
    },
};
</script>

<style scoped>
/* Card Pratica */
.sa-siat-card-pratica {
    border: none;
    border-radius: 12px;
    margin-bottom: 25px;
    overflow: hidden;
}

.sa-siat-card-header-custom {
    background: #fff;
    border-bottom: 1px solid #edf2f7;
    padding: 15px 20px;
}

/* Sezione Prestazioni */
.sa-siat-prestazione-item {
    border: 1px solid #e2e8f0;
    margin: 8px 20px;
    border-radius: 8px;
    background: #fff;
    transition: all 0.2s ease;
}

.sa-siat-prestazione-header {
    padding: 12px 15px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.sa-siat-prestazione-header:hover {
    background: #f8fafc;
}

/* Colori per Figura */
.sa-siat-border-IP {
    border-left: 5px solid #3498db;
}

.sa-siat-border-FISIO {
    border-left: 5px solid #2ecc71;
}

.sa-siat-border-OSS {
    border-left: 5px solid #e67e22;
}

.sa-siat-border-PSIC {
    border-left: 5px solid #9b59b6;
}

.sa-siat-border-MED {
    border-left: 5px solid #e74c3c;
}

.sa-siat-text-IP {
    color: #3498db !important;
}

.sa-siat-text-FISIO {
    color: #2ecc71 !important;
}

.sa-siat-text-OSS {
    color: #e67e22 !important;
}

.sa-siat-text-PSIC {
    color: #9b59b6 !important;
}

.sa-siat-text-MED {
    color: #e74c3c !important;
}

.sa-siat-label-pai {
    font-weight: bold;
    color: #7f8c8d;
    text-transform: uppercase;
    font-size: 0.95rem;
}

.sa-siat-valore-pai {
    color: #2c3e50;
    font-weight: 600;
}

.sa-siat-cols {
    padding-right: 25px;
    padding-left: 25px;
}

.sa-siat-text-data {
    color: #c20000;
}

.sa-siat-text-indirizzo {
    font-size: 1rem;
}

.sa-siat-data {
    color: #e83e8c;
}

.sa-siat-badge {
    /* display: block; */
    font-size: 1rem;
    max-width: 200px;
}

.sa-siat-badge-aperta {
    color: #07af07;
}

.sa-siat-data-complesso {
    color: #e67e22;
}
</style>
